import axios from "axios";
import { API_URL } from "./UserServices";

// Single source of truth for the API base URL (see UserServices.js).
// axios strips a trailing slash, so add one back for baseURL joins.
const api = axios.create({
  baseURL: `${API_URL}/`,
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // You can add headers or perform other tasks before the request is sent
    const user = JSON.parse(localStorage.getItem("user") || "[]"); // Replace with how you store your token
    if (user) {
      config.headers.Authorization = `Bearer ${user?.token ?? ""}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // You can process successful responses here
    return response;
  },
  (error) => {
    // 401 only. A 403 used to be swept up here too, which now means "signed in
    // but no live subscription" - clearing the session and bouncing to the
    // sign-up form would throw the user out of an account that is working
    // perfectly well. It is left to the caller, which can explain it.
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/Signup";
    }
    return Promise.reject(error);
  }
);

export default api;
